import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import dhid from 'dhid';

import Content from '../../components/Content';
import Empty from '../../components/Empty';
import Header from '../../components/Header';
import Link from '../../../../components/Link';
import Loader from '../../components/Loader';
import Map from './Map';
import styles from './map.scss';

const propTypes = {
  onRequestOpenFn: PropTypes.func.isRequired,
  event: PropTypes.shape({
    id: PropTypes.string,
    activities: PropTypes.array,
    pub_exhibitors: PropTypes.array,
  }),
  framed: PropTypes.bool,
  loading: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      node: PropTypes.string,
      activity: PropTypes.string,
      map: PropTypes.string,
      shortcode: PropTypes.string,
      exhibitor: PropTypes.string,
    }),
  }),
  maps: PropTypes.shape({
    filter: PropTypes.func,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

class Maps extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      onRequestOpenFn, event, loading, history, framed, match,
    } = this.props;

    // Make a list of published maps available for this event
    const maps = this.props.maps.filter(
      (map) => event && map.get('published') && map.get('event') === event.id,
    );

    // Figure out what maps, if any to display
    let pin = null;
    let mapId = null;

    // If URL contains a activity id
    if (match.params.activity) {
      const activity = event && event.activities.find((a) => a.id === match.params.activity);
      const coordinate = activity && activity.area && /^([^:]+)(:([^,]+),(.+))?$/.exec(activity.area.pin);

      if (coordinate) {
        const [, mId,, lat, lon] = coordinate;
        mapId = mId;
        pin = {
          coordinate: { lat, lon },
          title: activity.area.name,
          body: activity.title,
        };
      }
    }

    // If URL contains a exhibitor id and an optional coordinate
    if (match.params.exhibitor) {
      const exhibitor = event && event.pub_exhibitors.find((a) => a.id === match.params.exhibitor);
      const coordinate = exhibitor && /^([^:]+)(:([^,]+),(.+))?$/.exec(exhibitor.pin || (exhibitor.area && exhibitor.area.pin));

      if (coordinate) {
        const [, mId,, lat, lon] = coordinate;
        mapId = mId;
        if (lat && lon) {
          pin = {
            coordinate: { lat, lon },
            title: (exhibitor.area && exhibitor.area.name),
            body: exhibitor.name,
          };
        }
      }
    }

    // If URL contains a map id and an optional coordinate
    if (match.params.map) {
      const coordinate = /^([^:]+)(:([^,]+),(.+))?$/.exec(match.params.map);

      if (coordinate) {
        const [, mId,, lat, lon] = coordinate;
        mapId = mId;
        if (lat && lon) {
          pin = {
            coordinate: { lat, lon },
            title: 'HERE!',
          };
        }
      }
    }

    const map = mapId ? maps.find((m) => mapId && m.get('id') === mapId) : maps.first();

    const mapTabs = maps && maps.size > 1 && maps.map((m) => ({
      title: m.get('title'),
      onClick: () => history.replace(`/app/event/${match.params.shortcode}/maps/${m.get('id')}`),
      active: map?.get('id') === m?.get('id'),
    })).toArray();

    const showHeader = !framed;

    return (
      <>
        {showHeader && (
          <Header
            onMenuOpen={onRequestOpenFn}
            onBack={pin ? () => history.goBack() : undefined}
            history={history}
            showUser
            {...(maps.size > 1 ? { tabs: mapTabs } : {})}
          >
            { maps.size > 1 ? 'Maps' : 'Map' }
          </Header>
        )}
        <Content>
          <Loader loading={loading} />
          <Empty
            empty={!loading && maps && maps.size === 0}
            title="There is no map for this event yet."
            message="We probably haven't uploaded the map yet, but check back later to see if it's up!"
          />
          {maps && map && (
            <Map map={map} pin={pin} event={event} />
          )}
          {maps && !map && (
            <>
              <div className={styles.maps}>
                {maps
                  .map((m) => (
                    <Link
                      to={`/app/event/${match.params.shortcode}/maps/${m.get('id')}`}
                      key={m.get('id')}
                      className={styles.map}
                    >
                      <div>
                        <img
                          src={`${dhid.getFilebankUrl()}/maps/${m.get(
                            'id',
                          )}/0/0/0.png`}
                          alt="Preview is not available"
                          title={m.get('title')}
                        />
                      </div>
                      <div className={styles.title}>{m.get('title')}</div>
                    </Link>
                  ))
                  .toArray()}
              </div>
            </>
          )}
        </Content>
      </>
    );
  }
}

Maps.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.getIn(['event', 'loading']),
    event: state.getIn(['event', 'data']),
    maps: state.getIn(['maps', 'list']),
  };
}

export default connect(mapStateToProps)(Maps);
